import React, { createContext, useContext, useEffect, useState } from 'react';
import { get, post } from 'aws-amplify/api';


const DBDataSyncContext = createContext();
export const DBDataProvider = ({ children }) => {
    const [TagsData, setTagsData] = useState([]);

    const getStoredData = async () => {
        const storedTags = localStorage.getItem("localStoredTags") || "[]"
        setTagsData(JSON.parse(storedTags));
    };

    const tagDataFromBack = async() => {
        try{
            const responseGet = await get({
                apiName: 'BackendSyncAPI',
                path: '/',
                options: {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                },
            }).response;
            
            const response = await responseGet.body.json();
            setTagsData(response);
            localStorage.setItem("localStoredTags", JSON.stringify(response));
        } catch(error){
            console.log("Sync back error: ", error)
        }
    };

    useEffect(() => {
        getStoredData();
        tagDataFromBack();
    }, [])


    const contextValue = { TagsData };
    
    return <DBDataSyncContext.Provider value={contextValue}>{children}</DBDataSyncContext.Provider>;
};

export const BackSyncedData = () => useContext(DBDataSyncContext);